// Polyfill for ie11
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import "./index.scss";

import { Provider as RollbarProvider } from "@rollbar/react";
import { rollbarConfig } from "lib/rollbarConfig";
import React, { useEffect } from "react";
import { createRoot } from "react-dom/client";
import TagManager from "react-gtm-module";
import { Provider } from "react-redux";
import store from "store/configureStore";

import * as serviceWorker from "./serviceWorker";
import { App } from "./ui/App";

function RootApp() {
  useEffect(() => {
    TagManager.initialize({
      gtmId: process.env.REACT_APP_GOOGLE_TAGMANAGER_ID || "",
    });
  }, []);

  return (
    <RollbarProvider config={rollbarConfig}>
      <Provider store={store}>
        <App />
      </Provider>
    </RollbarProvider>
  );
}

const root = createRoot(document.getElementById("root"));
root.render(<RootApp />);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
